/** A soft bezier curve for nice transitions. */
export const softBezier = 'cubic-bezier(0.4, 0, 0.2, 1)';
